export interface VendorPrice {
  retailer: string;
  url: string;
  price: number | null; // null means out of stock or price unavailable
  inStock: boolean;
  lastUpdated: string;
}

export interface GPUPricing {
  gpuId: string;
  msrp: number;
  vendors: VendorPrice[];
}

// Mock price data - in production this would come from an API
export const gpuPricing: Record<string, GPUPricing> = {
  'rtx-5090': {
    gpuId: 'rtx-5090',
    msrp: 1999,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5090', price: 2199, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5090', price: 2149, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5090', price: 1999, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'B&H Photo', url: 'https://bhphotovideo.com/c/search?q=rtx+5090', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+5090', price: 1999, inStock: false, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4090': {
    gpuId: 'rtx-4090',
    msrp: 1599,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4090', price: 1849, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4090', price: 1799, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4090', price: 1599, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'B&H Photo', url: 'https://bhphotovideo.com/c/search?q=rtx+4090', price: 1699, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4090', price: 1579, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-5080': {
    gpuId: 'rtx-5080',
    msrp: 999,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5080', price: 1099, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5080', price: 1049, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5080', price: 999, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+5080', price: 999, inStock: false, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4080-super': {
    gpuId: 'rtx-4080-super',
    msrp: 999,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4080+super', price: 979, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4080+super', price: 969, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4080+super', price: 999, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'B&H Photo', url: 'https://bhphotovideo.com/c/search?q=rtx+4080+super', price: 989, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4080+super', price: 949, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-5070-ti': {
    gpuId: 'rtx-5070-ti',
    msrp: 749,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5070+ti', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5070+ti', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5070+ti', price: 749, inStock: false, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4080': {
    gpuId: 'rtx-4080',
    msrp: 1199,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4080', price: 949, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4080', price: 899, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4080', price: 929, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4080', price: 879, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4070-ti-super': {
    gpuId: 'rtx-4070-ti-super',
    msrp: 799,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4070+ti+super', price: 779, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4070+ti+super', price: 769, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4070+ti+super', price: 799, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'B&H Photo', url: 'https://bhphotovideo.com/c/search?q=rtx+4070+ti+super', price: 789, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4070+ti+super', price: 749, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-5070': {
    gpuId: 'rtx-5070',
    msrp: 549,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+5070', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+5070', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+5070', price: 549, inStock: false, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4070-ti': {
    gpuId: 'rtx-4070-ti',
    msrp: 799,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4070+ti', price: 699, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4070+ti', price: 679, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4070+ti', price: 699, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4070+ti', price: 659, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4070-super': {
    gpuId: 'rtx-4070-super',
    msrp: 599,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4070+super', price: 579, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4070+super', price: 569, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4070+super', price: 599, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'B&H Photo', url: 'https://bhphotovideo.com/c/search?q=rtx+4070+super', price: 589, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4070+super', price: 559, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4070': {
    gpuId: 'rtx-4070',
    msrp: 549,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4070', price: 529, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4070', price: 519, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4070', price: 549, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4070', price: 499, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4060-ti': {
    gpuId: 'rtx-4060-ti',
    msrp: 399,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4060+ti', price: 389, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4060+ti', price: 379, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4060+ti', price: 399, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4060+ti', price: 369, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-4060': {
    gpuId: 'rtx-4060',
    msrp: 299,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+4060', price: 289, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+4060', price: 279, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+4060', price: 299, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+4060', price: 269, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-3060': {
    gpuId: 'rtx-3060',
    msrp: 329,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+3060', price: 259, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+3060', price: 249, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+3060', price: 279, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+3060', price: 239, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rtx-3050': {
    gpuId: 'rtx-3050',
    msrp: 249,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rtx+3050', price: 169, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rtx+3050', price: 159, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rtx+3050', price: 179, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rtx+3050', price: 149, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-7900-xtx': {
    gpuId: 'rx-7900-xtx',
    msrp: 999,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7900+xtx', price: 899, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7900+xtx', price: 879, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7900+xtx', price: 929, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+7900+xtx', price: 849, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-9070-xt': {
    gpuId: 'rx-9070-xt',
    msrp: 649,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+9070+xt', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+9070+xt', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+9070+xt', price: 649, inStock: false, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-7900-xt': {
    gpuId: 'rx-7900-xt',
    msrp: 899,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7900+xt', price: 749, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7900+xt', price: 729, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7900+xt', price: 779, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+7900+xt', price: 699, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-9070': {
    gpuId: 'rx-9070',
    msrp: 549,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+9070', price: null, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+9070', price: null, inStock: false, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-7900-gre': {
    gpuId: 'rx-7900-gre',
    msrp: 549,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7900+gre', price: 529, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7900+gre', price: 519, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7900+gre', price: 549, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+7900+gre', price: 499, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-7800-xt': {
    gpuId: 'rx-7800-xt',
    msrp: 499,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7800+xt', price: 459, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7800+xt', price: 449, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7800+xt', price: 479, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+7800+xt', price: 429, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-7700-xt': {
    gpuId: 'rx-7700-xt',
    msrp: 449,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7700+xt', price: 399, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7700+xt', price: 389, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7700+xt', price: 419, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+7700+xt', price: 379, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-7600-xt': {
    gpuId: 'rx-7600-xt',
    msrp: 329,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7600+xt', price: 309, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7600+xt', price: 299, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7600+xt', price: 329, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+7600+xt', price: 289, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-7600': {
    gpuId: 'rx-7600',
    msrp: 269,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+7600', price: 249, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+7600', price: 239, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=rx+7600', price: 259, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+7600', price: 229, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-6700-xt': {
    gpuId: 'rx-6700-xt',
    msrp: 479,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+6700+xt', price: 279, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+6700+xt', price: 269, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+6700+xt', price: 249, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'rx-6600': {
    gpuId: 'rx-6600',
    msrp: 329,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=rx+6600', price: 179, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=rx+6600', price: 169, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=rx+6600', price: 159, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'arc-b580': {
    gpuId: 'arc-b580',
    msrp: 249,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=intel+arc+b580', price: 259, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=intel+arc+b580', price: 249, inStock: false, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=intel+arc+b580', price: 249, inStock: false, lastUpdated: '2024-12-16' },
    ],
  },
  'arc-a770': {
    gpuId: 'arc-a770',
    msrp: 349,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=intel+arc+a770', price: 289, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=intel+arc+a770', price: 279, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=intel+arc+a770', price: 299, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=intel+arc+a770', price: 269, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
  'arc-a750': {
    gpuId: 'arc-a750',
    msrp: 289,
    vendors: [
      { retailer: 'Amazon', url: 'https://amazon.com/s?k=intel+arc+a750', price: 199, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Newegg', url: 'https://newegg.com/p/pl?d=intel+arc+a750', price: 189, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Best Buy', url: 'https://bestbuy.com/site/searchpage.jsp?st=intel+arc+a750', price: 209, inStock: true, lastUpdated: '2024-12-16' },
      { retailer: 'Micro Center', url: 'https://microcenter.com/search/search_results.aspx?N=&Ntt=intel+arc+a750', price: 179, inStock: true, lastUpdated: '2024-12-16' },
    ],
  },
};

export interface LowestPrice {
  price: number;
  retailer: string;
  url: string;
  savings: number;
  savingsPercent: number;
}

export function getLowestPrice(gpuId: string): LowestPrice | null {
  const pricing = gpuPricing[gpuId];
  if (!pricing) return null;

  const inStockVendors = pricing.vendors.filter(v => v.inStock && v.price !== null);
  if (inStockVendors.length === 0) return null;

  const lowest = inStockVendors.reduce((min, v) => 
    (v.price! < min.price!) ? v : min
  );

  return {
    price: lowest.price!,
    retailer: lowest.retailer,
    url: lowest.url,
    savings: pricing.msrp - lowest.price!,
    savingsPercent: Math.round(((pricing.msrp - lowest.price!) / pricing.msrp) * 100),
  };
}

export function getGPUPricing(gpuId: string): GPUPricing | null {
  return gpuPricing[gpuId] || null;
}

export function getAllVendorPrices(gpuId: string): VendorPrice[] {
  return gpuPricing[gpuId]?.vendors || [];
}
